// extracted by mini-css-extract-plugin
module.exports = {"main":"TapNgoTimer_main__JqSS6","active":"TapNgoTimer_active__ysHV8","disabled":"TapNgoTimer_disabled__dFLjl"};